import { Permissions } from "../permissions";

export const SuperAdminRolePermissions = [...Permissions];